
import Vue from "vue";
import { uniq } from "lodash";
import agentCodeService from "@/services/agentCode.service";

interface IData {
  loading: boolean;
  agentCodes: string[];
}

export default Vue.extend({
  name: "search-select-agent-codes",
  props: {
    selected: {
      type: [Number, String, Array, Boolean],
      default: ""
    },
    value: {
      type: [Number, String, Array, Boolean],
      default: undefined
    },
    label: {
      type: String,
      default: "",
      required: false
    },
    preFetch: {
      type: Boolean,
      required: false,
      default: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: "Type to search agent codes"
    }
  },
  mounted() {
    if (this.preFetch) {
      this.remoteMethod("");
    }
  },
  data(): IData {
    return {
      loading: false,
      agentCodes: []
    };
  },
  methods: {
    async remoteMethod(searchTerm: string) {
      try {
        this.loading = true;
        const response = await agentCodeService.getAgentCodes(
          searchTerm ? { __query: searchTerm } : {}
        );
        const data = Array.isArray(response.data) ? response.data : [];
        this.agentCodes = data
          .map(agentCode =>
            typeof agentCode === "string"
              ? agentCode
              : agentCode.agentCode || agentCode.code || agentCode.value
          )
          .filter(Boolean);
      } catch (error) {
        this.$appNotifyError("Error fetching agent codes");
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
      }
    },
    selectedCodes(): string[] {
      const selected = this.effectiveSelected;
      if (Array.isArray(selected)) {
        return selected.filter(
          (code): code is string => typeof code === "string"
        );
      }
      return typeof selected === "string" && selected ? [selected] : [];
    }
  },
  computed: {
    effectiveSelected(): any {
      return this.value !== undefined ? this.value : this.selected;
    },
    agentCodeOptions(): { label: string; value: string; key: string }[] {
      // Keep already-selected codes in the option list so their chips/labels
      // stay visible even when the latest search results don't include them.
      const codes = uniq([...this.selectedCodes(), ...this.agentCodes]);
      return codes.map(code => ({
        label: code,
        value: code,
        key: code
      }));
    }
  }
});
